/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { PreFooterProps } from './index';

/**
 * Base styles for the pre footer component
 *
 * @param {PreFooterProps} props The pre footer properties object
 * */
const baseStyles = (props: PreFooterProps) => css`
    .pre-footer {
        padding: 4.8rem 0;
        border-top: 0.1rem solid var(--colors-border-light);
    }

    ${smallTablet(css`
        display: none;
    `)}
`;

/**
 * The pre footer component styles
 *
 * @param {PreFooterProps} props The pre footer properties object
 * */
export const styles = (props: PreFooterProps) => css`
    ${baseStyles(props)}
`;
